export const NIGERIAN_SERVICE_AREAS = [
  'Abuja',
  'Lagos',
  'Port Harcourt',
  'Abia',
  'Adamawa',
  'Akwa Ibom',
  'Anambra',
  'Bauchi',
  'Bayelsa',
  'Benue',
  'Borno',
  'Cross River',
  'Delta',
  'Ebonyi',
  'Edo',
  'Ekiti',
  'Enugu',
  'Gombe',
  'Imo',
  'Jigawa',
  'Kaduna',
  'Kano',
  'Katsina',
  'Kebbi',
  'Kogi',
  'Kwara',
  'Nasarawa',
  'Niger',
  'Ogun',
  'Ondo',
  'Osun',
  'Oyo',
  'Plateau',
  'Sokoto',
  'Taraba',
  'Yobe',
  'Zamfara',
] as const

export type NigerianServiceArea = (typeof NIGERIAN_SERVICE_AREAS)[number]

const SERVICE_AREA_ALIASES: Record<string, string[]> = {
  abuja: ['abuja', 'fct'],
  lagos: ['lagos'],
  'port harcourt': ['port harcourt', 'rivers'],
}

export function getServiceAreaAliases(selectedArea: string): string[] {
  const normalized = selectedArea.trim().toLowerCase()
  return SERVICE_AREA_ALIASES[normalized] ?? [normalized]
}

export function matchesServiceArea(selectedArea: string, dbState?: string | null): boolean {
  if (!dbState) return false
  const normalizedDbState = dbState.trim().toLowerCase()
  return getServiceAreaAliases(selectedArea).includes(normalizedDbState)
}

export function isValidServiceArea(value: string): boolean {
  return NIGERIAN_SERVICE_AREAS.some(
    (area) => area.toLowerCase() === value.trim().toLowerCase()
  )
}

export const PRESET_SERVICE_AREAS = NIGERIAN_SERVICE_AREAS.map((state) => ({
  country: 'Nigeria',
  state,
}))
